import { Component, Input, ViewEncapsulation, Inject, HostListener, ViewChild, Directive, Output, ElementRef } from '@angular/core';
import { SideMenuService } from '../../side-menu/side-menu.service';
import { ResponsiveBreakpointsService } from '../../responsive-breakpoints/responsive-breakpoints.service';
import { APP_BASE_HREF } from '@angular/common';
import { filter } from 'rxjs/operators/filter';
import { Router } from '@angular/router';
import { NotifierService } from '../../../shared/notifier/notifier.service';
import { HsMenuService } from '../../../services/hs-menu.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-top-navbar-content',
  styleUrls: ['./styles/top-navbar-content.scss'],
  templateUrl: './top-navbar-content.component.html',
  encapsulation: ViewEncapsulation.None
})
export class TopNavbarContentComponent {
  @Input('messages') messages = [];
  @Input('notifications') notifications = [];
  userMgmt: any = {};
  nombreUsuario = '';
  firstLetter = '';
  sideMenuVisible = true;
  openSideMenu = false;
  baseUrl = '';
  menuFunctions: Array<any> = [];
  constructor(
    private sideMenuService: SideMenuService,
    private responsiveService: ResponsiveBreakpointsService,
    private notifierService: NotifierService,
    private hsMenuService: HsMenuService,
    private _router: Router,
    @Inject(APP_BASE_HREF) private baseHref: string
  ) {
    this.obtenerNombreUsuario();
    this.loadMenuOptions();
    this.baseUrl = baseHref;
    this.notifierService.userMgmtObject$.subscribe((user) => {
      this.userMgmt = user;
      this.nombreUsuario = this.userMgmt.nombres + ' ' + this.userMgmt.apellidos;
      this.firstLetter = this.nombreUsuario.charAt(0)
    });

    responsiveService.responsiveSubject
      .pipe(
        filter(breakpoint => breakpoint.screen === 'xs-or-sm')
      )
      .subscribe(breakpoint => {
        if (breakpoint.active) {

          this.openSideMenu = true;
          this.sideMenuService.sidenav.mode = 'push';
          this.sideMenuService.sidenav.close().then(
            val => {
              // console.log('ok closing');
              this.sideMenuVisible = false;
            },
            err => {
              // console.log('error closing');
            },
            () => {
              // console.log('all closing');
            }
          );
        } else {
          this.openSideMenu = false;
          this.sideMenuService.sidenav.mode = 'side';
        }
      });
  }

  toggleSideMenu(): void {
    this.sideMenuService.sidenav.toggle().then(
      val => {
        this.sideMenuVisible = !this.sideMenuVisible;
      },
      err => {
        // console.log('error toggle');
      },
      () => {
        // console.log('all toggle');
      }
    );
  }

  cerrarSesion() {
    localStorage.removeItem('jwt');
    localStorage.removeItem('nombreCompleto');
    localStorage.clear();
    this._router.navigate(['/public/login']);
  }

  obtenerNombreUsuario() {
    if (localStorage.getItem('nombreCompleto')) {
      this.nombreUsuario = localStorage.getItem('nombreCompleto')
    } else {
      this.nombreUsuario = this.userMgmt.nombres + ' ' + this.userMgmt.apellidos;
      localStorage.setItem('nombreCompleto', this.nombreUsuario);
    }
  }

  loadMenuOptions() {
    this.hsMenuService.getMenu().subscribe(
      (result: Array<any>) => {
        this.menuFunctions = result;
      }, (error) => {
        console.log(error);
      })
  }
  hideDropdown($event) {
    document.getElementById("dropdown-profile").classList.remove('dropdown-content-load');
  }
  showDropdown() {
    document.getElementById("dropdown-profile").classList.add('dropdown-content-load');
  }
  legacyFunction(name) {
    console.log(name);
    switch (name) {
      case 'TimeSheet':
      //this._router.navigate(['/system/tiempo', { externalUrl: 'localhost:4300/#' }]);
      window.open(environment.TBWALEGACY_URL +
          '/#/system/tiempo/' +
          localStorage.getItem('jwt'),
          '_blank')
        break;
    
      default:
        break;
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/system/core/top-navbar/content/top-navbar-content.component.ts